import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      {/* Hero Section */}
      <section className="policy-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Terms of Service</h1>
            <p className="hero-subtitle">Terms and conditions for using our website</p>
            <p className="hero-description">
              Last updated: December 2024
            </p>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-text">
            <div className="policy-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the DHRTI MAA website, you accept and agree to be bound 
                by the terms and provision of this agreement.
              </p>
              <p>
                If you do not agree to abide by the above, please do not use this service.
              </p>
            </div>

            <div className="policy-section">
              <h2>2. Use License</h2>
              <p>
                Permission is granted to temporarily download one copy of the materials on 
                DHRTI MAA's website for personal, non-commercial transitory viewing only.
              </p>
              <p>This is the grant of a license, not a transfer of title, and under this license you may not:</p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>3. Product Information</h2>
              <p>
                We strive to provide accurate product information, descriptions, and images. 
                However, we do not warrant that product descriptions or other content is accurate, 
                complete, reliable, current, or error-free.
              </p>
              <p>
                Product prices and availability are subject to change without notice.
              </p>
            </div>

            <div className="policy-section">
              <h2>4. Disclaimer</h2>
              <p>
                The materials on DHRTI MAA's website are provided on an 'as is' basis. 
                DHRTI MAA makes no warranties, expressed or implied, and hereby disclaims 
                and negates all other warranties including without limitation, implied 
                warranties or conditions of merchantability, fitness for a particular purpose, 
                or non-infringement of intellectual property or other violation of rights.
              </p>
            </div>

            <div className="policy-section">
              <h2>5. Limitations</h2>
              <p>
                In no event shall DHRTI MAA or its suppliers be liable for any damages 
                (including, without limitation, damages for loss of data or profit, or due 
                to business interruption) arising out of the use or inability to use the 
                materials on DHRTI MAA's website, even if DHRTI MAA or a DHRTI MAA authorized 
                representative has been notified orally or in writing of the possibility 
                of such damage.
              </p>
            </div>

            <div className="policy-section">
              <h2>6. Accuracy of Materials</h2>
              <p>
                The materials appearing on DHRTI MAA's website could include technical, 
                typographical, or photographic errors. DHRTI MAA does not warrant that any 
                of the materials on its website are accurate, complete, or current.
              </p>
              <p>
                DHRTI MAA may make changes to the materials contained on its website at 
                any time without notice.
              </p>
            </div>

            <div className="policy-section">
              <h2>7. Links</h2>
              <p>
                DHRTI MAA has not reviewed all of the sites linked to our website and is 
                not responsible for the contents of any such linked site. The inclusion 
                of any link does not imply endorsement by DHRTI MAA of the site.
              </p>
            </div>

            <div className="policy-section">
              <h2>8. Modifications</h2>
              <p>
                DHRTI MAA may revise these terms of service for its website at any time 
                without notice. By using this website you are agreeing to be bound by the 
                then current version of these terms of service.
              </p>
            </div>

            <div className="policy-section">
              <h2>9. Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in accordance 
                with the laws of India and you irrevocably submit to the exclusive 
                jurisdiction of the courts in that state or location.
              </p>
            </div>

            <div className="policy-section">
              <h2>10. Contact Information</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="contact-info">
                <p><strong>Email:</strong> DhrtiMaaOrganics@gmail.com</p>
                <p><strong>Phone:</strong> +91 8890060211</p>
                <p><strong>Address:</strong> Balaji Vihar-29, VKIA, Jaipur-302013</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
